import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },*/
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
     key: 'name',
     field: FIELDS.NAME,
     title: 'Company',
     label: 'Company',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     locked: true,
     width: 300,
  },{
     key: 'accountClassName',
     field: FIELDS.ACCOUNT_CLASS_NAME,
     title: 'Account Class',
     label: 'Account Class',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorTypeName',
     field: FIELDS.VENDOR_TYPE_NAME,
     title: 'Vendor Type',
     label: 'Vendor Type',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'phone1',
     field: FIELDS.PHONE1,
     title: 'Phone1',
     label: 'Phone1',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'fax1',
     field: FIELDS.FAX1,
     title: 'Fax1',
     label: 'Fax1',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'email1',
     field: FIELDS.EMAIL1,
     title: 'Email1',
     label: 'Email1',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesPerson1FullName',
     field: FIELDS.SALES_PERSON1_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'recentNote',
     field: FIELDS.RECENT_NOTE,
     title: 'Recent Note',
     label: 'Recent Note',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'overallRating',
     field: FIELDS.OVERALL_RATING,
     title: 'Rating',
     label: 'Rating',
     cell: 'formatRating',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'webSite',
     field: FIELDS.WEBSITE,
     title: 'Website',
     label: 'Website',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'revenue',
     field: FIELDS.REVENUE,
     title: 'Revenue',
     label: 'Revenue',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'companySize',
     field: FIELDS.COMPANY_SIZE,
     title: 'Employees',
     label: 'Employees',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'accountNumber',
     field: FIELDS.ACCOUNT_NUMBER,
     title: 'AccountNo',
     label: 'AccountNo',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'sicCode',
     field: FIELDS.SICCODE,
     title: 'SIC',
     label: 'SIC',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'naicsCode',
     field: FIELDS.NAICSCODE,
     title: 'NAICS',
     label: 'NAICS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxId',
     field: FIELDS.TAX_ID,
     title: 'Tax Id',
     label: 'Tax Id',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vatNumber',
     field: FIELDS.VATNUMBER,
     title: 'VAT Number',
     label: 'VAT Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'timezone',
     field: FIELDS.TIMEZONE,
     title: 'Timezone',
     label: 'Timezone',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'scope',
     field: FIELDS.SCOPE,
     title: 'Scope',
     label: 'Scope',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'billingCountryCode',
     field: FIELDS.BILLING_COUNTRY_CODE,
     title: 'Country',
     label: 'Country',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'doNotCall',
     field: FIELDS.DO_NOT_CALL,
     title: 'Do Not Call',
     label: 'Do Not Call',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'doNotEmail',
     field: FIELDS.DO_NOT_EMAIL,
     title: 'Do Not Email',
     label: 'Do Not Email',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'legalName',
     field: FIELDS.LEGAL_NAME,
     title: 'Legal Name',
     label: 'Legal Name',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'division',
     field: FIELDS.DIVISION,
     title: 'Division',
     label: 'Division',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'accountImageUrl',
     field: FIELDS.ACCOUNT_IMAGE_URL,
     title: 'AccountImageUrl',
     label: 'AccountImageUrl',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone2',
     field: FIELDS.PHONE2,
     title: 'Phone2',
     label: 'Phone2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'phone3',
     field: FIELDS.PHONE3,
     title: 'Phone3',
     label: 'Phone3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'fax2',
     field: FIELDS.FAX2,
     title: 'Fax2',
     label: 'Fax2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'fax3',
     field: FIELDS.FAX3,
     title: 'Fax3',
     label: 'Fax3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'email2',
     field: FIELDS.EMAIL2,
     title: 'Email2',
     label: 'Email2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sourcingEmail',
     field: FIELDS.SOURCING_EMAIL,
     title: 'SourcingEmail',
     label: 'SourcingEmail',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salesPerson2FullName',
     field: FIELDS.SALES_PERSON2_FULL_NAME,
     title: 'Alt Sales Person',
     label: 'Alt Sales Person',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'buyer1FullName',
     field: FIELDS.BUYER1_FULL_NAME,
     title: 'Buyer',
     label: 'Buyer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'buyer2FullName',
     field: FIELDS.BUYER2_FULL_NAME,
     title: 'Alt Buyer',
     label: 'Alt Buyer',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingAddress1',
     field: FIELDS.SHIPPING_ADDRESS1,
     title: 'Shipping Address 1',
     label: 'Shipping Address 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress2',
     field: FIELDS.SHIPPING_ADDRESS2,
     title: 'Shipping Address 2',
     label: 'Shipping Address 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress3',
     field: FIELDS.SHIPPING_ADDRESS3,
     title: 'Shipping Address 3',
     label: 'Shipping Address 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingCity',
     field: FIELDS.SHIPPING_CITY,
     title: 'Shipping City',
     label: 'Shipping City',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingState',
     field: FIELDS.SHIPPING_STATE,
     title: 'Shipping State',
     label: 'Shipping State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingZipCode',
     field: FIELDS.SHIPPING_ZIP_CODE,
     title: 'Shipping Zip Code',
     label: 'Shipping Zip Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingCountryCode',
     field: FIELDS.SHIPPING_COUNTRY_CODE,
     title: 'Shipping Country Code',
     label: 'Shipping Country Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingPhone',
     field: FIELDS.SHIPPING_PHONE,
     title: 'Shipping Phone',
     label: 'Shipping Phone',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingContactName',
     field: FIELDS.SHIPPING_CONTACT_NAME,
     title: 'Shipping Contact Name',
     label: 'Shipping Contact Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress1',
     field: FIELDS.BILLING_ADDRESS1,
     title: 'Billing Address 1',
     label: 'Billing Address 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress2',
     field: FIELDS.BILLING_ADDRESS2,
     title: 'Billing Address 2',
     label: 'Billing Address 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress3',
     field: FIELDS.BILLING_ADDRESS3,
     title: 'Billing Address 3',
     label: 'Billing Address 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingCity',
     field: FIELDS.BILLING_CITY,
     title: 'Billing City',
     label: 'Billing City',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingState',
     field: FIELDS.BILLING_STATE,
     title: 'Billing State',
     label: 'Billing State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingZipCode',
     field: FIELDS.BILLING_ZIP_CODE,
     title: 'Billing Zip Code',
     label: 'Billing Zip Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingPhone',
     field: FIELDS.BILLING_PHONE,
     title: 'Billing Phone',
     label: 'Billing Phone',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingContactName',
     field: FIELDS.BILLING_CONTACT_NAME,
     title: 'Billing Contact Name',
     label: 'Billing Contact Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingTermsName',
     field: FIELDS.BILLING_TERMS_NAME,
     title: 'Billing Terms',
     label: 'Billing Terms',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'creditLimit',
     field: FIELDS.CREDIT_LIMIT,
     title: 'Credit Limit',
     label: 'Credit Limit',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencySymbol',
     field: FIELDS.CURRENCY_SYMBOL,
     title: 'Currency Symbol',
     label: 'Currency Symbol',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorBillingTermsName',
     field: FIELDS.VENDOR_BILLING_TERMS_NAME,
     title: 'Vendor Billing TermsName',
     label: 'Vendor Billing TermsName',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorCreditLimit',
     field: FIELDS.VENDOR_CREDIT_LIMIT,
     title: 'Vendor Credit Limit',
     label: 'Vendor Credit Limit',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'vendorCurrencyTypeName',
     field: FIELDS.VENDOR_CURRENCY_TYPE_NAME,
     title: 'Vendor Currency Type',
     label: 'Vendor Currency Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'referralSource',
     field: FIELDS.REFERRAL_SOURCE,
     title: 'ReferralSource',
     label: 'ReferralSource',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tradeEntity',
     field: FIELDS.TRADE_ENTITY,
     title: 'Trade Entity',
     label: 'Trade Entity',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dunAndBradstreet',
     field: FIELDS.DUN_AND_BRADSTREET,
     title: 'Dun And Bradstreet',
     label: 'Dun And Bradstreet',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankName',
     field: FIELDS.BANK_NAME,
     title: 'Bank Name',
     label: 'Bank Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankContact',
     field: FIELDS.BANK_CONTACT,
     title: 'Bank Contact',
     label: 'Bank Contact',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankAccountNumber',
     field: FIELDS.BANK_ACCOUNT_NUMBER,
     title: 'Bank Account Number',
     label: 'Bank Account Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankAddress',
     field: FIELDS.BANK_ADDRESS,
     title: 'Bank Address',
     label: 'Bank Address',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankCity',
     field: FIELDS.BANK_CITY,
     title: 'Bank City',
     label: 'Bank City',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankState',
     field: FIELDS.BANK_STATE,
     title: 'Bank State',
     label: 'Bank State',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankPostalCode',
     field: FIELDS.BANK_POSTAL_CODE,
     title: 'Bank Postal Code',
     label: 'Bank Postal Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankCountry',
     field: FIELDS.BANK_COUNTRY,
     title: 'Bank Country',
     label: 'Bank Country',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankPhone',
     field: FIELDS.BANK_PHONE,
     title: 'Bank Phone',
     label: 'Bank Phone',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'bankFax',
     field: FIELDS.BANK_FAX,
     title: 'Bank Fax',
     label: 'Bank Fax',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isAvl',
     field: FIELDS.IS_AVL,
     title: 'AVL',
     label: 'AVL',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
